import { render, staticRenderFns } from "./sysTake.vue?vue&type=template&id=f7563536&scoped=true&"
import script from "./sysTake.vue?vue&type=script&lang=js&"
export * from "./sysTake.vue?vue&type=script&lang=js&"
import style0 from "./sysTake.vue?vue&type=style&index=0&id=f7563536&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7563536",
  null
  
)

export default component.exports